module.exports = __webpack_public_path__ + "static/media/Agriculture.5383f548.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/About/Tracks/img/newlogos/Agriculture.svg
// module id = 241
// module chunks = 0